import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { MatomoRouteInterceptorBase } from '@ngx-matomo/router';
import { MatomoTracker } from '@ngx-matomo/tracker';

@Injectable()
export class MatomoInterceptor extends MatomoRouteInterceptorBase<string> {
  constructor(private readonly tracker: MatomoTracker, router: Router) {
    super(router);
  }

  protected extractRouteData(route: ActivatedRouteSnapshot): string {
    return `${route.routeConfig?.title || 'ResistMap'} ${
      route.paramMap.get('id') ? ' - ' + route.paramMap.get('id') : ''
    }`;
  }

  protected async processRouteData(title: string): Promise<void> {
    this.tracker.setDocumentTitle(title);
  }
}
